import { Platform } from 'react-native';

export const API_URL =
	Platform.OS === 'android'
		? 'http://192.168.1.221:5000'
		: 'https://api.jacobawebb.com:443'; //'http://localhost:5000';
